import { definitionFactory } from '../definitionFactory';
import { onDeleteAction } from '../definitionsDeleteAction';

function formatPriceNumber(value: number): string {
  if (value >= 1000000) {
    const millions = value / 1000000;

    return millions % 1 === 0 ? `${millions} млн` : `${millions.toFixed(1).replace('.', ',')} млн`;
  }

  if (value >= 1000) {
    const thousands = value / 1000;

    return thousands % 1 === 0 ? `${thousands} тыс` : `${thousands.toFixed(1).replace('.', ',')} тыс`;
  }

  return String(value);
}

function rangePriceStr(gte?: number, lte?: number, isPerSquareMeter?: boolean) {
  const suffix = isPerSquareMeter ? ' ₽ за м²' : ' ₽';

  if (gte && lte) {
    return `${formatPriceNumber(gte)}–${formatPriceNumber(lte)}${suffix}`;
  }
  if (gte) {
    return `От ${formatPriceNumber(gte)}${suffix}`;
  }
  if (lte) {
    return `До ${formatPriceNumber(lte)}${suffix}`;
  }

  return 'Цена';
}

export const priceInputDefinition = definitionFactory({
  key: 'price',
  mapper: ({ gte, lte }, _tags, appState) => {
    const isPerSquareMeter = appState.jsonQuery.price_sm?.value === true;

    return gte || lte
      ? [
          {
            label: rangePriceStr(gte, lte, isPerSquareMeter),
            value: { gte, lte },
          },
        ]
      : [];
  },
  onDeleteAction: (value, options = {}) => {
    return onDeleteAction(value, 'price', options);
  },
});
